import { PhotoGalleryTypeEnum } from '@utmb/types/enum/PhotoGalleryTypeEnum';
import { Slice } from '@utmb/types/slice-handler';
import SlicePhotoGalleryView from '@utmb/types/view/SlicePhotoGalleryView';
import React, { ReactElement } from 'react';
import Caroussel from '../caroussel/Caroussel';
import GalleryDS from '../gallery/Gallery';

export const PhotosLayout = (props: Slice<SlicePhotoGalleryView>): ReactElement => {
    const { type, photos } = props;

    const typeOfLayout = {
        [PhotoGalleryTypeEnum.GALLERY]: <GalleryDS photos={photos} />,
        [PhotoGalleryTypeEnum.SQUARED_GALLERY]: <GalleryDS photos={photos} isSquared={true} />,
        [PhotoGalleryTypeEnum.SLIDESHOW]: <Caroussel autoplay={true} imgs={photos} />,
    };

    return <>{photos && photos.length > 0 ? typeOfLayout[type] : null}</>;
};
